import createHistory from 'history/createHashHistory';

import {runInAction, autorun} from 'mobx';

import * as constants from './model/const';

import {Flasher} from './view/Flasher/model';
import {Api} from './api';
import {History} from './model/History';


import {Scene} from './model/Scene';

import {SessionStorage} from './model/SessionStorage';
import {Persist} from './model/Persist';
import {Router} from './model/Router';

import confirmationDialog from './model/ConfirmationDialog';

import {RentalObject} from './model/RentalObject';
import {BestOffers} from './model/BestOffers';
import {AllotmentDetails} from './model/AllotmentDetails';
import {Store} from './model/Store';
import {BusinessUnit} from './model/BusinessUnit';
import {Organization} from './model/Organization';
import {SearchResults} from './model/SearchResults';
import {Hierarchy} from './model/Hierarchy';
import {MasterData} from './model/MasterData';
import {RentalTransaction} from './model/RentalTransaction';

import {RentalServiceApi} from './api/RentalServiceApi';
import {RentalAccessoryApi} from './api/RentalAccessoryApi';

import {OrgTimeUnit} from './aggregate/OrgTimeUnit';
import {Parameters as AggParameters} from './aggregate/Parameters';

import {VMaster} from './view/VMaster';
import {Navigation} from './model/Navigation';

import {SearchForm} from './view/SearchForm';
import {VSearch} from './view/VSearch';
import {VObjectDetails} from './view/VObjectDetails';
import {VHome} from './view/VHome';
import {VOfferDetails} from './view/VOfferDetails';
import {OfferDetailsForm} from './view/OfferDetailsForm';
import {Services as AggServices} from './aggregate/Services';
import {ServicesForm} from './view/ServicesForm';
import {VServices} from './view/VServices';
import {Accessories as AggAccessories} from './aggregate/Accessories';
import {VBookingWizard} from './view/VBookingWizard';
import {AccessoriesForm} from './view/AccessoriesForm';
import {VAccessories} from './view/VAccessories';
import {VReview} from './view/VReview';
import {VFinished} from './view/VFinished';

import {PersonalDataForm, PersonalAddressForm} from './view/PersonalDataForm';
import {VPersonalData} from './view/VPersonalData';
import {PersonalData} from './model/PersonalData';

import {LoginForm} from './view/LoginForm';
import {Authentication} from './model/Authentication';

import {VPayment} from './view/VPayment';
import {VUserProfile} from './view/VUserProfile';
import {VUserRegistration} from './view/VUserRegistration';
import {Validator} from './model/Validator';

import {VRecentBookings} from './view/VRecentBookings';
import {VRecentBookingDetail} from './view/VRecentBookingDetail';

import {PasswordRecoveryEmailForm} from './view/PasswordRecoveryEmailForm';
import {PasswordRecoveryPasswordForm} from './view/PasswordRecoveryPasswordForm';
import {VForgottenPassword} from './view/VForgottenPassword';


//import {Redirect} from './model/Redirect';



export function build() {
  const history = createHistory();
  const historyAdp = new History(history);
  const scene = new Scene(historyAdp, Object.values(constants.VIEWS));
  const sessionStorage = new SessionStorage();


  const flasher = new Flasher();
  const api = new Api(flasher);

  const vMaster = new VMaster(); 
  const navigation = new Navigation(scene, history, vMaster, sessionStorage);  

  const masterData = new MasterData(api);
  const hierarchy = new Hierarchy(api);
  const organization = new Organization(api);
  const bestOffers = new BestOffers(api);
  const rentalTransaction = new RentalTransaction(api);
  const orgTimeUnit = new OrgTimeUnit(organization, masterData);
  const loginForm = new LoginForm();
  const authentication = new Authentication(flasher, api, loginForm, rentalTransaction, organization);  
  const businessUnit = new BusinessUnit(api, () => vMaster.orgId);
  const rentalObject = new RentalObject(api, organization, businessUnit);
  const allotmentDetails = new AllotmentDetails(api, organization);

  const searchForm = new SearchForm(
    flasher,
    api, 
    hierarchy, 
    orgTimeUnit,
    () => {},
  );

  const offerDetailsForm = new OfferDetailsForm();
  const servicesForm = new ServicesForm();
  const accessoriesForm = new AccessoriesForm();

  const rentalServiceApi = new RentalServiceApi(api, rentalTransaction);
  const rentalAccessoryApi = new RentalAccessoryApi(api, rentalTransaction);  

  const searchResults = new SearchResults(navigation, api, organization, searchForm);
  const aggParameters = new AggParameters(searchResults);
  

  const aggServices = new AggServices(rentalObject, bestOffers, rentalTransaction, businessUnit);
  const aggAccessories = new AggAccessories(rentalObject, bestOffers, rentalTransaction);

  const vBookingWizard = new VBookingWizard(flasher, aggServices, aggAccessories);

  const vSearch = new VSearch(
    flasher, 
    api, 
    searchForm, 
    searchResults, 
    masterData, 
    organization, 
    businessUnit);


  const vHome = new VHome(
    flasher, 
    api, 
    searchForm, 
    searchResults, 
    masterData, 
    organization,
  )

  const vObjectDetails = new VObjectDetails(
    flasher, 
    rentalObject, 
    masterData, 
    organization, 
    businessUnit, 
    allotmentDetails,
    searchForm,
    bestOffers
  )

  const validator = new Validator();
  const personalDataForm = new PersonalDataForm(validator);
  const personalAddressForms = [
    new PersonalAddressForm(constants.ADDRESS_TYPE.POST, validator), 
    new PersonalAddressForm(constants.ADDRESS_TYPE.RECHNUNG, validator), 
    new PersonalAddressForm(constants.ADDRESS_TYPE.LIEFER, validator),
  ];

  const vOfferDetails = new VOfferDetails(
    flasher, 
    (trxId) => {
      sessionStorage.setState({trxId});
    },
    searchForm, 
    rentalObject, 
    bestOffers, 
    offerDetailsForm, 
    rentalTransaction, 
    authentication,
    aggAccessories, 
    allotmentDetails, 
    rentalAccessoryApi, 
    businessUnit,
    organization,
    vBookingWizard,
    personalDataForm, 
    personalAddressForms
  );

  const vServices = new VServices(
    flasher, 
    navigation, 
    rentalObject, 
    bestOffers, 
    servicesForm, 
    searchForm,
    rentalTransaction, 
    organization, 
    businessUnit, 
    aggServices, 
    rentalServiceApi,
    vBookingWizard
  );

  const vAccessories = new VAccessories(
    flasher, 
    navigation, 
    rentalObject, 
    bestOffers, 
    accessoriesForm, 
    searchForm,
    offerDetailsForm,
    rentalTransaction, 
    organization, 
    businessUnit, 
    aggAccessories, 
    rentalAccessoryApi,
    vBookingWizard
  );
  

  const personalData = new PersonalData(flasher, api, scene, authentication);

  const vUserRegistration  = new VUserRegistration(
    flasher, 
    api, 
    navigation, 
    masterData, 
    authentication, 
    personalData, 
    rentalTransaction, 
    personalDataForm, 
    personalAddressForms
  );  

  const vPersonalData = new VPersonalData(
    flasher, 
    api, 
    navigation, 
    organization, 
    masterData, 
    authentication, 
    personalData, 
    rentalTransaction,
    rentalObject,  
    businessUnit, 
    bestOffers, 
    personalDataForm, 
    personalAddressForms, 
    validator,
    vUserRegistration,
    searchForm,
    vBookingWizard
  );  
  navigation.vPersonalData = vPersonalData;


  const vReview = new VReview(
    flasher,
    navigation, 
    servicesForm, 
    accessoriesForm, 
    rentalTransaction, 
    rentalObject, 
    bestOffers,
    vServices, 
    vAccessories, 
    businessUnit,
    searchForm, 
    vBookingWizard
  );  

  const vPayment = new VPayment(
    flasher, 
    api,
    navigation, 
    organization, 
    rentalTransaction, 
    rentalObject, 
    businessUnit, 
    bestOffers,
    searchForm,
    authentication, 
    personalDataForm, 
    personalAddressForms, 
    vReview,
    vPersonalData,
    vBookingWizard
  ); 
  vReview.vPayment = vPayment; 

  const vFinished = new VFinished(
    flasher, 
    api,
    navigation, 
    organization, 
    rentalTransaction, 
    rentalObject, 
    businessUnit,
    vBookingWizard,
    vReview,
    personalDataForm, 
    personalAddressForms    
  )

  const vUserProfile  = new VUserProfile(
    flasher, 
    api, 
    navigation, 
    masterData, 
    authentication, 
    personalData, 
    rentalTransaction, 
    personalDataForm, 
    personalAddressForms
  );



  const passwordRecoveryEmailForm = new PasswordRecoveryEmailForm();
  const passwordRecoveryPasswordForm = new PasswordRecoveryPasswordForm();
  const vForgottenPassword = new VForgottenPassword(
    flasher, 
    api, 
    navigation, 
    passwordRecoveryEmailForm, 
    passwordRecoveryPasswordForm
  );  

  const vRecentBookings = new VRecentBookings(
    flasher, 
    api, 
    navigation
  );

  const vRecentBookingDetail = new VRecentBookingDetail(
    flasher, 
    api, 
    navigation,
    rentalObject,
    organization,
  );  

  const router = new Router(
    Object.values(constants.VIEWS),
    history,
    authentication,
    vMaster, 
    vHome, 
    vSearch, 
    vObjectDetails,
    vOfferDetails,
    vServices,
    vAccessories,
    vPersonalData,
    vReview,
    vPayment,
    vUserProfile,
    vUserRegistration,  
    vRecentBookings,
    vRecentBookingDetail,  
    vForgottenPassword,
    vFinished,
    vBookingWizard
  );  


  history.listen(router.handleHistoryChange);
  router.handleHistoryChange(history.location, undefined)

  if(false) {

    router.onRedirect = (view, state) => {
      state = state || {};
      scene.replaceMerged(view, state);
      //sceneEdited(view, state);
    }

    router.onRedirectUnmerged = (view, state) => {
      state = state || {};
      scene.replace(view, state);
      //sceneEdited(view, state);
    }

    function historyEdited(loc, act) {
      const {view, state} = scene.getCurrentState();
      sceneEdited(view, state);
    }


    historyAdp.setOnChange(historyEdited);

    function sceneEdited(view, urlState) {
      vMaster.handleSceneChange(view, urlState);
      //urlReactions.fixScene(view, state);

      sessionStorage.setState(urlState);
      let state = {
        ...urlState,
        ...sessionStorage.getState(),
      }

      searchForm.reset(sessionStorage.getState());

      if(!router.handleSceneChange(view, urlState, state)) {
        // redirect...
        return;
      }
      
      
    }

    searchForm.onChange = values => {
      sessionStorage.setState(values);
    }

    

    //const persist = new Persist(sessionStorage, vMaster, searchForm);


    /*const redirect = new Redirect([
      //() => vMaster.redirectSource,
    ], scene, history, sceneEdited);  */

    function sessionStorageEdited() {
      const state = sessionStorage.getState();
      vMaster.handleSessionStorageChange(state);
      //searchForm.reset(state);
    }

    runInAction(() => {
      // Take url and propagte it..
      historyEdited(historyAdp.location, historyAdp.action);
      //sessionStorageEdited();


      //searchForm.startReactions();
      //persist.startReactions();
      //redirect.startReactions();
      //vHome.startReactions();
      //vSearch.startReactions();
      //navigation.startReactions();
      //urlReactions.startReactions();
      //vObjectDetails.startReactions();
      //vOfferDetails.startReactions();
      //vServices.startReactions();
    });

  }

  return {
    flasher,
    vMaster,
    vHome,
    vSearch,
    vObjectDetails,
    searchForm,
    masterData,
    organization,
    authentication,
    loginForm,
    navigation,
    aggParameters, 
    searchResults,
    businessUnit,
    rentalObject,
    aggServices,
    aggAccessories,
    allotmentDetails,
    vOfferDetails,
    bestOffers,
    rentalTransaction,
    vBookingWizard,
    offerDetailsForm,
    vServices,
    servicesForm,
    vAccessories,
    accessoriesForm,
    personalDataForm,
    personalAddressForms,
    vPersonalData,
    vReview,
    vPayment,
    vFinished,
    vUserProfile,
    vUserRegistration,
    vRecentBookings,
    vRecentBookingDetail,
    passwordRecoveryEmailForm,
    passwordRecoveryPasswordForm,
    vForgottenPassword,
    router,
    history,
    confirmationDialog,
  }
}




// WEBPACK FOOTER //
// ./src/integration.js